export default {
  load: null,
};
